import * as React from "react";
import { callApi } from "../../utils/api";
import Select from 'react-select';
import { isEmpty } from 'lodash';
import { Bank } from "../bank/ManageBank";
import { ToastsStore } from "react-toasts";
import LoginBillingFields from "../login-billing/LoginBillingFields";
import { isMergeBillType, isSingleBillType, canAcceptFeeAmountInput, normalizeFeeAmountDisplay, stripLoginBillingServiceChargesFromPayload, validateBankBranchFeeFields, validateLoginBillingFields } from "../../utils/loginBillingUtils";
export interface Officer {
  name: string;
  email: string;
  mobile: string;
  designation: string;

}
interface AllProps {
  history: any;
  match: any;
}
class AddBankBranch extends React.Component<AllProps> {
  state = {
    branchdetail: {
      id: 0,
      name: "",
      lawhands_branch: "",
      bank_idfk: "",
      product_id: "",
      mob_no: "",
      branch: "",
      address: "",
      vetting_fees: "",
      login_fees: "",
      bill_type_id: "",
      single_bill_detail: "",
      fees_type: "",
      lh_branch: "",
      bill_receive_to_mail: "",
      cc_mail: "",
      // ec_service_charge: "",
      // cc_service_charge: "",
      mutation: "",
      officer_list: []
    },
    billTypes: [],
    banks: [],
    products: [],
    filteredProduct: [],
    lawhandsBranches: [],
    isRequired: false,
    isLoading: false,
    selectedBranchIds: [] as number[],
    formFields: {
      selectedBranchId: [] as number[],
    },
  };
  componentDidMount() {
    this.listBank();
    this.listBankproduct();
    this.getLawHandsBranches();
    this.getBillTypes();
    if (Number(this.props.match.params.id)) {
      this.getSingleBranch();
    } else {
      this.addItem();
    }
  }
  listBank = () => {
    callApi("GET", "bank_get.php")
      .then(res => res.data)
      .then(response => {
        this.setState({ banks: response.data });
      })
      .catch(err => {
        console.log(err);
      });
  };
  listBankproduct = () => {
    this.setState({ isFileRefresh: false });
    callApi("GET", "bank_product_get.php")
      .then(res => res.data)
      .then(response => {
        const files = response.data;
        this.setState({ products: files, filteredProduct: files });
      })
      .catch(err => {
        console.log(err);
      });
  };
  getLawHandsBranches() {
    callApi("GET", "get_branch.php")
      .then(res => res.data)
      .then(response => {
        this.setState({ lawhandsBranches: response.data });
      })
      .catch(err => {
        console.log(err);
      });
  }
  getBillTypes() {
    callApi("GET", "bill_type_get.php")
      .then(res => res.data)
      .then(response => {
        this.setState({ billTypes: response.data || [] });
      })
      .catch(err => {
        console.log(err);
      });
  }
  getSingleBranch() {
    callApi("POST", "bank_branch_get_one.php", {
      id: this.props.match.params.id
    })
      .then(res => res.data)
      .then(response => {
        if (
          response &&
          response.data &&
          response.data.length &&
          response.data[0].arr &&
          response.data[0].arr[0]
        ) {
          const branchdetail = Object.assign(response.data[0].arr[0]);
          branchdetail.officer_list = response.data[0].rl;
          this.setState({ branchdetail });
          console.log("branchdetail---", branchdetail);
          if (branchdetail.bank_idfk) {
            this.filterProduct(branchdetail.bank_idfk);
          }
          const selectedBranchId = branchdetail.lawhands_branch && Array.from(new Set(branchdetail.lawhands_branch.split(',').map(id => id.trim()).filter(id => id)));
          this.setState({
            formFields: {
              selectedBranchId
            }
          });

        }
      });
  }
  handleChange1 = (e: any, propName?, fieldType?) => {
    const branchdetail: any = this.state.branchdetail;
    let fieldName = fieldType === 'singleselect' ? propName : e.target.name;
    let fieldValue = fieldType === 'singleselect' ? e.value : e.target.value;
    branchdetail[fieldName] = fieldValue;
    this.setState({ branchdetail });
    if (fieldName === "bank_idfk") {
      this.filterProduct(fieldValue);
    }
  };
  filterProduct = bankid => {
    if (bankid) {
      const filteredProduct = this.state.products.filter(
        (branch: any) => branch.bank_id === bankid
      );
      const state = this.state;
      state.filteredProduct = filteredProduct;
      this.setState({ ...state });
    } else {
      this.setState({ product_id: "" })
    }
  };
  handleChange = (e: any) => {
    const { name, value } = e.target;
    if (["vetting_fees", "login_fees"].includes(name) && !canAcceptFeeAmountInput(value)) {
      return;
    }
    const branchdetail: any = this.state.branchdetail;
    branchdetail[name] = value;
    this.setState({ branchdetail });
  };
  handleBillingChange = (e: any, propName?: string, fieldType?: string) => {
    const branchdetail: any = { ...this.state.branchdetail };
    const fieldName = fieldType === "singleselect" ? propName : e.target.name;
    const fieldValue = fieldType === "singleselect" ? (e ? e.value : "") : e.target.value;
    if (["login_fees", "mutation"].includes(fieldName) && fieldType !== "singleselect" && !canAcceptFeeAmountInput(fieldValue)) {
      return;
    }
    if (fieldName === "bill_type_id") {
      if (!isMergeBillType(this.state.billTypes, fieldValue)) {
        branchdetail.lh_branch = "";
      }
      if (!isSingleBillType(this.state.billTypes, fieldValue)) {
        branchdetail.single_bill_detail = "";
      }
    }
    branchdetail[fieldName] = fieldValue;
    this.setState({ branchdetail });
  };
  addItem = (): void => {
    const officer_list: Officer[] = this.state.branchdetail.officer_list
      ? this.state.branchdetail.officer_list
      : [];
    officer_list.push({ name: "", mobile: "", email: "", designation: "" });
    this.setState({
      branchdetail: { ...this.state.branchdetail, officer_list }
    });
  };
  removeItem = (index: number): void => {
    const officer_list: Officer[] = this.state.branchdetail.officer_list;
    officer_list.splice(index, 1);
    this.setState({
      branchdetail: { ...this.state.branchdetail, officer_list }
    });
  };
  handleOfficerChange = (e: any, index: number) => {
    const officer_list: Officer[] = this.state.branchdetail.officer_list;
    officer_list.forEach((itm: any, i) => {
      if (i === index) {
        itm[e.target.name] = e.target.value;
      }
    });
    this.setState({
      branchdetail: { ...this.state.branchdetail, officer_list }
    });
  };
  saveBranch = () => {
    this.props.match.params.id = Number(this.props.match.params.id);
    if (isEmpty(this.state.formFields.selectedBranchId) || isEmpty(this.state.branchdetail.bank_idfk) || isEmpty(this.state.branchdetail.product_id) || isEmpty(this.state.branchdetail.name) || isEmpty(this.state.branchdetail.address)) {
      ToastsStore.error('Required fields are empty');
      this.setState({ isRequired: true });
      return;
    }
    const billingError = validateLoginBillingFields(
      { ...this.state.branchdetail, billTypes: this.state.billTypes }
    );
    if (billingError) {
      ToastsStore.error(billingError);
      return;
    }
    const branchFeeError = validateBankBranchFeeFields(this.state.branchdetail);
    if (branchFeeError) {
      ToastsStore.error(branchFeeError);
      return;
    }
    this.setState({ isRequired: false, isLoading: true });
    if (this.props.match.params.id) {
      callApi("POST", "bank_branch_update.php", stripLoginBillingServiceChargesFromPayload({ ...this.state.branchdetail, selectedBranchId: this.state.formFields.selectedBranchId }))
        .then(res => res.data)
        .then(response => {
          console.log("111", response);
          this.props.history.push("/bank-branch");
        })
        .catch(err => {
          console.log(err);
          ToastsStore.error("Something went wrong, please try again");
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    } else {
      callApi("POST", "bank_branch_create.php", stripLoginBillingServiceChargesFromPayload({ ...this.state.branchdetail, selectedBranchId: this.state.formFields.selectedBranchId }))
        .then(res => res.data)
        .then(response => {
          if (response.status == true) {
            this.props.history.push("/bank-branch");
          } else {
            ToastsStore.error(response.message);
          }
        })
        .catch(err => {
          console.log(err);
          ToastsStore.error("Something went wrong, please try again");
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    }
  };

  handleBranchChange = (selectedOptions: any) => {
    this.setState({
      formFields: {
        ...this.state.formFields,
        selectedBranchId: selectedOptions ? selectedOptions.map((opt: any) => opt.value) : []
      }
    }, () => { });
  };

  render() {
    const filteredProduct = [
      { value: "", label: "" },
      ...this.state.filteredProduct
    ];

    const { lawhandsBranches, formFields } = this.state;

    const options = lawhandsBranches && lawhandsBranches.map((opt: any) => ({
      label: opt.name,
      value: opt.id
    }));

    const selectedValues = formFields.selectedBranchId && formFields.selectedBranchId.map(id =>
      options.find(option => option.value === id)
    );
    return (
      <div className="pcoded-main-container">
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card">
                        <div className="card-header">
                          <h5>Bank Branch Form</h5>
                          <button
                            className="btn btn-primary"
                            style={{ float: "right" }}
                            onClick={() => this.props.history.goBack()}
                          >
                            Back
                          </button>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Lawhands Branch<span style={{ color: "red" }}>*</span></label>
                                {/* {this.state.lawhandsBranches && this.state.lawhandsBranches.length > 0 && this.state.lawhandsBranches.map((opt: any) => {
                                  opt.label = opt.name; opt.value = opt.id
                                }) &&
                                  <Select isMulti closeMenuOnSelect={false} options={this.state.lawhandsBranches} name="lawhands_branch"
                                    value={this.state.lawhandsBranches.find((o: any) => o.value === this.state.branchdetail.lawhands_branch)}
                                    onChange={(e) => this.handleChange1(e, 'lawhands_branch', 'singleselect')}
                                  />
                                } */}
                                {this.state.lawhandsBranches && this.state.lawhandsBranches.length > 0 && (
                                  <Select
                                    options={options}
                                    name="mybranch"
                                    closeMenuOnSelect={false}
                                    isMulti
                                    value={selectedValues}
                                    onChange={this.handleBranchChange}
                                  />
                                )}
                                {this.state.branchdetail.lawhands_branch == "" && this.state.isRequired == true && <div className="pt-1" style={{ fontSize: "11px", color: "#dc3545" }}>*Required Field</div>}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Bank Name<span style={{ color: "red" }}>*</span></label>
                                {this.state.banks && this.state.banks.length > 0 && this.state.banks.map((opt: any) => {
                                  opt.label = opt.name; opt.value = opt.id
                                }) &&
                                  <Select options={this.state.banks} name="bank_idfk"
                                    value={this.state.banks.find((o: any) => o.value === this.state.branchdetail.bank_idfk)}
                                    onChange={(e) => this.handleChange1(e, 'bank_idfk', 'singleselect')}
                                  />
                                }
                                {this.state.branchdetail.bank_idfk == "" && this.state.isRequired == true && <div className="pt-1" style={{ fontSize: "11px", color: "#dc3545" }}>*Required Field</div>}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Product<span style={{ color: "red" }}>*</span></label>
                                {this.state.products && this.state.products.map((opt: any) => {
                                  opt.label = opt.product_name; opt.value = opt.id
                                }) &&
                                  <Select options={filteredProduct} name="product_id"
                                    value={this.state.filteredProduct.find((o: any) => o.value === this.state.branchdetail.product_id)}
                                    onChange={(e) => this.handleChange1(e, 'product_id', 'singleselect')}
                                  />
                                }
                                {this.state.branchdetail.product_id == "" && this.state.isRequired == true && <div className="pt-1" style={{ fontSize: "11px", color: "#dc3545" }}>*Required Field</div>}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Branch Name<span style={{ color: "red" }}>*</span></label>
                                {/* {this.state.lawhandsBranches && this.state.lawhandsBranches.length > 0 && this.state.lawhandsBranches.map((opt: any) => {
                                  opt.label = opt.name; opt.value = opt.name
                                }) &&
                                  <Select options={this.state.lawhandsBranches} name="name"
                                    value={this.state.lawhandsBranches.find((o: any) => o.name === this.state.branchdetail.name)}
                                    onChange={(e) => this.handleChange1(e, 'name', 'singleselect')}
                                  />
                                } */}
                                <input
                                  type="text"
                                  name="name"
                                  className="form-control"
                                  onChange={e => this.handleChange(e)}
                                  value={this.state.branchdetail.name}
                                  placeholder="Branch Name"
                                />
                                {this.state.branchdetail.name == "" && this.state.isRequired == true && <div className="pt-1" style={{ fontSize: "11px", color: "#dc3545" }}>*Required Field</div>}
                              </div>
                            </div>
                            <div className="col-md-8"></div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Address<span style={{ color: "red" }}>*</span></label>
                                <textarea
                                  name="address"
                                  onChange={e => this.handleChange(e)}
                                  className="form-control"
                                  value={this.state.branchdetail.address}
                                  placeholder="Address"
                                />
                                {this.state.branchdetail.address == "" && this.state.isRequired == true && <div className="pt-1" style={{ fontSize: "11px", color: "#dc3545" }}>*Required Field</div>}
                              </div>
                            </div>
                            
                          
                            <div className="col-md-3">
                              <div className="form-group">
                                <label>Vetting Fees<span style={{ color: "red" }}>*</span></label>
                                <input
                                  type="text"
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  name="vetting_fees"
                                  className={!this.state.branchdetail.vetting_fees ? "form-control is-invalid" : "form-control"}
                                  onChange={e => this.handleChange(e)}
                                  value={normalizeFeeAmountDisplay(this.state.branchdetail.vetting_fees)}
                                  placeholder="Vetting Fees"
                                />
                                <div className="invalid-feedback">*Required Field</div>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="form-group">
                                <label>Legal Login Fees<span style={{ color: "red" }}>*</span></label>
                                <input
                                  type="text"
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  name="login_fees"
                                  className={!this.state.branchdetail.login_fees ? "form-control is-invalid" : "form-control"}
                                  onChange={e => this.handleChange(e)}
                                  value={normalizeFeeAmountDisplay(this.state.branchdetail.login_fees)}
                                  placeholder="Login Fees"
                                />
                                <div className="invalid-feedback">*Required Field</div>
                              </div>
                            </div>
                            <LoginBillingFields
                              state={{
                                ...this.state.branchdetail,
                                billTypes: this.state.billTypes,
                                lawhandsBranches: this.state.lawhandsBranches,
                              }}
                              required={false}
                              handleChange={this.handleBillingChange}
                              hideLoginFees={true}
                            />
                            <div className="text-right col-md-11">
                              <button
                                type="button"
                                className="btn btn-primary btn-sm "
                                onClick={() => this.addItem()}
                              >
                                Add +
                              </button>
                            </div>
                            <br />
                            {this.state.branchdetail.officer_list &&
                              this.state.branchdetail.officer_list.map(
                                (officer: Officer, index: number) => {
                                  return (
                                    <div className="row" key={index}>
                                      <div className="col-md-3">
                                        <div className="form-group">
                                          <label>Name</label>
                                          <input
                                            type="text"
                                            name="name"
                                            className="form-control"
                                            placeholder="Name"
                                            value={officer.name}
                                            onChange={e =>
                                              this.handleOfficerChange(e, index)
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-3">
                                        <div className="form-group">
                                          <label>Designation</label>
                                          <input
                                            type="text"
                                            name="designation"
                                            value={officer.designation}
                                            onChange={e =>
                                              this.handleOfficerChange(e, index)
                                            }
                                            className="form-control"
                                            placeholder="Designation"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-3">
                                        <div className="form-group">
                                          <label>Phone</label>
                                          <input
                                            type="number"
                                            name="mobile"
                                            value={officer.mobile}
                                            onChange={e =>
                                              this.handleOfficerChange(e, index)
                                            }
                                            className="form-control"
                                            placeholder="Phone"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-3">
                                        <div className="form-group">
                                          <label>Email</label>
                                          <div className="row">
                                            <div className="col-md-10">
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Email"
                                                name="email"
                                                value={officer.email}
                                                onChange={e =>
                                                  this.handleOfficerChange(
                                                    e,
                                                    index
                                                  )
                                                }
                                              />
                                            </div>
                                            <div className="col-md-2">
                                              <button
                                                type="button"
                                                className="btn btn-icon btn-rounded btn-danger"
                                                onClick={() =>
                                                  this.removeItem(index)
                                                }
                                              >
                                                <i className="feather icon-trash" />
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                          </div>
                          <button
                            type="button"
                            className="btn btn-primary"
                            disabled={this.state.isLoading}
                            onClick={this.saveBranch}
                          >
                            {this.state.isLoading ? (
                              <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddBankBranch;
